import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { deepMix } from '@antv/util';
import { column, columnOf, inferredColumn, maybeColumnOf } from './utils/helper';
import { normalizeComparator, createGroups, applyOrder } from './utils/order';
/**
 * The stack transform group marks into series by color channel,
 * and then produce new y channel for each series by specified order,
 * say to form vertical "stacks" by specified channels.
 */
export var StackY = function StackY() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$groupBy = options.groupBy,
    groupBy = _options$groupBy === void 0 ? 'x' : _options$groupBy,
    _options$orderBy = options.orderBy,
    orderBy = _options$orderBy === void 0 ? null : _options$orderBy,
    _options$reverse = options.reverse,
    reverse = _options$reverse === void 0 ? false : _options$reverse,
    _options$y = options.y,
    fromY = _options$y === void 0 ? 'y' : _options$y,
    _options$y2 = options.y1,
    fromY1 = _options$y2 === void 0 ? 'y1' : _options$y2,
    _options$series = options.series,
    series = _options$series === void 0 ? true : _options$series;
  return function (I, mark) {
    var data = mark.data,
      encode = mark.encode,
      _mark$style = mark.style,
      style = _mark$style === void 0 ? {} : _mark$style;
    var _columnOf = columnOf(encode, 'y'),
      _columnOf2 = _slicedToArray(_columnOf, 2),
      Y = _columnOf2[0],
      fy = _columnOf2[1];
    var _columnOf3 = columnOf(encode, 'y1'),
      _columnOf4 = _slicedToArray(_columnOf3, 2),
      Y1 = _columnOf4[0],
      fy1 = _columnOf4[1];
    var _ref = series ? maybeColumnOf(encode, 'series', 'color') : columnOf(encode, 'color'),
      _ref2 = _slicedToArray(_ref, 1),
      S = _ref2[0]; // Create groups and apply specified order for each group.
    var groups = createGroups(groupBy, I, mark);
    var createComparator = normalizeComparator(orderBy);
    var comparator = createComparator(data, Y, S);
    if (comparator) applyOrder(groups, comparator);
    // Stack y channels to produce new y and y1 channel.
    var newY = new Array(I.length);
    var newY1 = new Array(I.length);
    var TY = new Array(I.length);
    var F = [];
    var L = [];
    var _iterator = _createForOfIteratorHelper(groups),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var G = _step.value;
        if (reverse) G.reverse();
        // For range interval with specified y and y1.
        var start = Y1 ? +Y1[G[0]] : 0;
        // Split positive indices of Y and negative Y.
        var PG = [];
        var NG = [];
        var _iterator2 = _createForOfIteratorHelper(G),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _i3 = _step2.value;
            var _y = TY[_i3] = +Y[_i3] - start;
            if (_y < 0) NG.push(_i3);else if (_y >= 0) PG.push(_i3);
          }
          // Store the first and last layer.
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        var FG = PG.length > 0 ? PG : NG;
        var LG = NG.length > 0 ? NG : PG;
        var i = PG.length - 1;
        var j = 0;
        // Find the last non-zero index.
        while (i > 0 && Y[FG[i]] === 0) i--;
        // Find the first non-zero index.
        while (j < LG.length - 1 && Y[LG[j]] === 0) j++;
        F.push(FG[i]);
        L.push(LG[j]);
        // Stack negative y in reverse order.
        var ny = start;
        var _iterator3 = _createForOfIteratorHelper(NG.reverse()),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _i4 = _step3.value;
            var _y2 = TY[_i4];
            ny = newY[_i4] = (newY1[_i4] = ny) + _y2;
          }
          // Stack positive y in input order.
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        var py = start;
        for (var _i = 0, _PG = PG; _i < _PG.length; _i++) {
          var _i2 = _PG[_i];
          var y = TY[_i2];
          if (y > 0) py = newY[_i2] = (newY1[_i2] = py) + y;else newY[_i2] = newY1[_i2] = py;
        }
      }
      // Only set top radius for the first layer,
      // and set bottom radius for the last layer.
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var FS = new Set(F);
    var LS = new Set(L);
    // Choose new y or y1 channel as the new y channel.
    var V = fromY === 'y' ? newY : newY1;
    var V1 = fromY1 === 'y' ? newY : newY1;
    return [I, deepMix({}, mark, {
      encode: {
        y0: inferredColumn(Y, fy),
        y: column(V, fy),
        y1: column(V1, fy1)
      },
      style: Object.assign({
        first: function first(_, i) {
          return FS.has(i);
        },
        last: function last(_, i) {
          return LS.has(i);
        }
      }, style)
    })];
  };
};
StackY.props = {};